import { Injectable } from '@angular/core';
import { ICurrency } from '@services/wallets/base-currency';

import symbolsWithIcon from '@common/symbols';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class CoinsService {
    constructor(private http: HttpClient) {}

    public async getSymbolIcon(_currency: ICurrency, _symbol?: string) {
        if (!!_currency) {
            const dbIconPath = _currency.getTokenIcon();
            if (!!dbIconPath) return dbIconPath;
        }

        const symbol = _currency?.getSymbol() || _symbol;
        if (symbol) {
            let exists: boolean = false;
            try {
                const response = await this.http
                    .get(
                        `/assets/images/symbols/${symbol.toLowerCase()}.svg?t=${Date.now()}`,
                        { responseType: 'blob' }
                    )
                    .toPromise();

                exists = response.type === 'image/svg+xml' && response.size > 0;
            } catch (e) {
                return '/assets/images/symbols/token-unknown.svg';
            }
            if (exists) {
                return `/assets/images/symbols/${symbol.toLowerCase()}.svg`;
            } else {
                return '/assets/images/symbols/token-unknown.svg';
            }
        } else {
            console.error('Symbol does not exists.');

            return '/assets/images/symbols/token-unknown.svg';
        }
    }

    public checkIfImageExists(
        url: string,
        callback: (exists: boolean) => void
    ) {
        const img = new Image();
        img.src = url;

        if (img.complete) {
            callback(true);
        } else {
            img.onload = () => {
                callback(true);
            };

            img.onerror = () => {
                callback(false);
            };
        }
    }

    // public getPlatformIcon(_platform: string) {
    //   if (_platform.toLowerCase() === ePlatforms.ETHEREUM.toLowerCase()) return '/assets/images/symbols/eth.svg';

    //   if (_platform.toLowerCase() === ePlatforms.BSC.toLowerCase()) return '/assets/images/symbols/bnb.svg';

    //   if (_platform.toLowerCase() === ePlatforms.POLYGON.toLowerCase()) return '/assets/images/symbols/matic.svg';

    //   if (_platform.toLowerCase() === ePlatforms.PULSECHAIN.toLowerCase()) return '/assets/images/symbols/pulse.svg';
    // }

    public parseExchangeSymbol(_symbol: string): string[] {
        const exchangeSymbol = _symbol.toUpperCase();
        let coins = exchangeSymbol.toUpperCase().split(/-|_|\/|\./g);

        if (coins.length === 2) {
            return coins;
        }

        symbolsWithIcon.some((_coinSymbol) => {
            const secondSymbol = exchangeSymbol.replace(_coinSymbol, '');
            if (
                exchangeSymbol.toUpperCase().startsWith(_coinSymbol) &&
                symbolsWithIcon.includes(secondSymbol)
            ) {
                coins = [_coinSymbol, secondSymbol];
                return true;
            }

            return false;
        });

        if (coins.length === 2) {
            return coins;
        }

        return [null, null];
    }
}
